

export default {
	watch: {
		isAll() {
			this.$nextTick(() => {
				this.$refs.tabs.scrollLeft = 0
			})
		}
	},
	props: {
		generations: Array,
		isAll: Boolean
	},
	mounted() {
		this.$nextTick(() => {
			if (localStorage.generationsTabsLeft && this.$device.isMobile && this.$refs.tabs) {
				this.$refs.tabs.scrollLeft = Number(localStorage.generationsTabsLeft)
			}
		})
	},
	methods: {
		scrollGenerations() {
			localStorage.generationsTabsLeft = event.target.scrollLeft
		},
	},
}
